<div *ngIf="form" [formGroup]="form">
  <div class="cord-label">
    <h3 class="label">{{ 'ACCESS_TYPE_MANAGEMENT' | translate }}</h3>
  </div>
  <div>
    <div>
      <app-auto-complete-list-group
        (selectChange)="onSelectChange($event)"
        (searchChange)="onSearchChange($event)"
        [removeSelectedItem]="removedItem"
        [itemsData]="adults"
        [selectedItemsData]="form.controls.adults.value"
        [inputTitle]="'ADD_ADULT' | translate"
      ></app-auto-complete-list-group>
      <app-form-error [control]="form.controls.adults"></app-form-error>
    </div>

  <!-- List of selected adults -->
  <ul class="list-group list-group-remove">
    <li *ngFor="let item of form.controls.adults.value" class="list-group-item">
      <b class="mr-3">{{ item?.extraLabels?.firstLabel }} {{ item?.extraLabels?.secondLabel }}</b>
      {{ item?.extraLabels?.thirdLabel }}
      <span class="ml-auto">
        <button
          type="button"
          class="round-btn round-btn-xs list-group-action ml-1"
          (click)="onRemove(item)"
          [attr.aria-label]="'REMOVE' | translate"
        >
          <i class="ftmi-cross" aria-hidden="true"></i>
        </button>
      </span>
    </li>
  </ul>
</div>
